module.exports = __webpack_public_path__ + "img/female_woman_person_people_avatar_icon_159366.c930126c.png";